module.exports = __webpack_public_path__ + "static/media/SleepDiagnostics.bdcdfd83.png";